
import Vue from "vue";
import AppCrmSelectAssignedForFilter from "@/components/crm/CrmSelectAssignedForFilter.vue";
import { HumanFilter } from "@/utils/human-filter";
import { CustomerService } from "@/services/customer-service";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>HumanFilter,
			required: true
		}
	},
	computed: {
		operator():string{
			if (this.value.Options.indexOf("not") == -1) {
				return "in";
			}
			return "not";
		},
		operators():ISelectItem<string>[]{
			return [
				{
					text: this.$ct("assigned-user-in-list"),
					value: "in"
				},
				{
					text: this.$ct("assigned-user-not-in-list"),
					value: "not-in"
				}
			];
		},
	},
	methods: {
		onUpdate(Ids: any){
			this.value.Values = Ids;
		},
		setOperator(value:string){
			let index = this.value.Options.indexOf("not");
			if (value == "in"){
				if (index == -1) return;
				this.value.Options.splice(index, 1);
			}else{
				if (index != -1) return;
				this.value.Options.push("not");
			}
		},
	},
	async mounted(){
		let ids = this.value.Values.map(v=>parseInt(v || "0")).filter(id=>!Number.isNaN(id) && id != 0);
		if (ids.length == 0) {
			this.value.Values = [];
			return;
		};
		let contacts = await CustomerService.getContactsByIDs(ids);
		this.value.Values = contacts.map(c=>`${c.ID}`);
	},
	components: {
		AppCrmSelectAssignedForFilter
	},
	i18nEx: {
		componentPrefix: "components.crm",
	}
});
